import React from 'react';
import ReactSpeedometer from 'react-d3-speedometer';

const MIN_VAL = 1;
const MAX_VAL = 5;

const ATRSpeedometer: React.FC<{value: number; label?: string}> = ({
  value,
  label = ' ',
}) => (
  <ReactSpeedometer
    minValue={MIN_VAL}
    maxValue={MAX_VAL}
    value={value}
    fluidWidth
    endColor="#22384f"
    startColor="#eef3f8"
    needleColor="#f0645a"
    currentValueText={label}
  />
);

export default ATRSpeedometer;
